<app-user-dashboard [userMenuActiveItemIndex]="0" [activeItem]="'direct-sale'">
  <p-breadcrumb class="max-w-full" [model]="breadcrumbItems" [home]="breadcrumbHomeItem"></p-breadcrumb>
  <div style="margin-top: 1em">
    <div class="card">
      <div class="header-card">
        <div class="container-title">
          <h2 class="title-main">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.PageTitle' | translate}}</h2>
        </div>
        <div class="flex justify-content-end align-items-center gap-4">
          <p-button (onClick)="showOfferDetailDialog()" styleClass="p-button-outlined">
            <span class="material-symbols-outlined">nutrition</span>
            <span>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.ViewExportOfferButtonLabel' | translate}}</span>
          </p-button>
        </div>
      </div>
      <div class="body-card">
        <p class="subtitle">{{'UserPages.UserClosedSale.ImporterClosedSaleOrders.PageDescriptionText' | translate}}</p>

        <div class="container-summary">
          <h3 class="title-summary">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.PageSubtitle' | translate}} {{ monthName }} {{ year }}</h3>
        </div>
        <div class="grid gap-0 mb-4 mt-5">

          <div class="col-2 flex justify-content-start card-colors" >
            <div class="col-12 flex justify-content-start p-0 m-0">
              <div class="grid card-summary total-amount-card border-50">
                <div class="col-12 md:col-12">
                  <p class="summary-title">{{'ImportCloseSaleDetail.TotalAmountSummary' | translate}}</p>
                </div>
                <div class="col-12 md:col-12">
                  <div class="grid">
                    <div class="col-1"></div>
                    <div class="col-10 flex justify-content-center align-items-center summary-card">
                      <span class="material-symbols-outlined icon-style">
                        monetization_on
                      </span>
                      <span class="summary-data">
                        {{totalPrice | currency: 'USD'}}
                      </span>
                    </div>
                    <div class="col-1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-2 flex justify-content-start card-colors">
            <div class="col-12 flex justify-content-start p-0 m-0">
              <div class="grid card-summary border-50 total-boxes-card">
                <div class="col-12 md:col-12">
                  <p class="summary-title">{{'ImportCloseSaleDetail.TotalBoxesSummary' | translate}}</p>
                </div>
                <div class="col-12 md:col-12">
                  <div class="grid">
                    <div class="col-1"></div>
                    <div class="col-10 flex justify-content-center align-items-center summary-card">
                      <span class="material-symbols-outlined icon-style">
                        inventory_2
                      </span>
                      <span class="summary-data">
                        {{totalBoxes | number:'1.0-0'}}
                      </span>
                    </div>
                    <div class="col-1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-2 flex justify-content-start card-colors">
            <div class="col-12 flex justify-content-start p-0 m-0">
              <div class="grid card-summary total-pallets-card border-50">
                <div class="col-12 md:col-12">
                  <p class="summary-title">{{'ImportCloseSaleDetail.TotalPalletsSummary' | translate}}</p>
                </div>
                <div class="col-12 md:col-12">
                  <div class="grid">
                    <div class="col-1"></div>
                    <div class="col-10 flex justify-content-center align-items-center summary-card">
                      <span class="material-symbols-outlined icon-style">
                        pallet
                      </span>
                      <span class="summary-data">
                        {{totalPalletsHistoric}}
                      </span>
                    </div>
                    <div class="col-1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-2 flex justify-content-start card-colors">
            <div class="col-12 flex justify-content-start p-0 m-0">
              <div class="grid card-summary border-50 total-containers-card">
                <div class="col-12 md:col-12">
                  <p class="summary-title">{{'ImportCloseSaleDetail.TotalContainers' | translate}}</p>
                </div>
                <div class="col-12 md:col-12">
                  <div class="grid">
                    <div class="col-1"></div>
                    <div class="col-10 flex justify-content-center align-items-center summary-card">
                      <span class="material-symbols-outlined icon-style">
                        package_2
                      </span>
                      <span class="summary-data">
                        {{totalContainers}}
                      </span>
                    </div>
                    <div class="col-1"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="pd-b">


          <div style="padding-bottom:1em">
            <div class="container-title">
                <h2 style="padding-top:1em;margin:0">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.CalendarTitle' | translate}}</h2>
            </div>
            <div class="flex align-items-center" style="margin-bottom:1em; margin-top: 1em;">
              <p-button
                  styleClass="p-button-outlined"
                  label="{{'UserPages.UserClosedSale.ProgramChartTitle' | translate}}"
                  icon="pi pi-chart-line" class="btn-icon" (onClick)="openChartDialog()">
              </p-button>
            </div>
            <p style="padding:.5em 0; margin:0;">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.CalendarSubtitle' | translate}}.</p>
          </div>

          <div class="card-border-sm">
            <div class="container-months">

              <div class="container-dropdown-sm">
                <!--
                  <small class="label-select">{{'MyLoadFilter.YearLabel' | translate}}</small>
                -->
                <p-dropdown
                  [options]="yearsList"
                  [(ngModel)]="yearCalendar"
                  (onChange)="onYearChange($event)"
                  [style]="{'background-color': '#EDEFF2', 'padding':'0'}"
                  >
                </p-dropdown>
              </div>

              <div class="divider"></div>
              <div class="section-months">
                <div *ngFor="let month of customMonths; let i = index"
                  class="chip-month"
                  (click)="handleMonths(month.name, month.id)"
                  [ngClass]="selectClassMonth(month.id)"
                  >{{getInitialLetters(month.name)}}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-5">
            <p-calendar
              #calendar
              [inline]="true"
              [showWeek]="true"
              [firstDayOfWeek]="1"
              [readonlyInput]="true"
              [(ngModel)]="dateCalendar"
              (onMonthChange)="onMonthChange($event)"
              [style]="{'width':'100%','height':'300px'}"
              >
              <ng-template pTemplate="date" let-date>
                  <span *ngIf="getWeekNumber(date.day, date.month, date.year)"  class="inWeekRange">
                    {{date.day}}
                  </span>
                  <span *ngIf="!getWeekNumber(date.day, date.month, date.year)">
                    {{date.day}}
                  </span>
              </ng-template>
            </p-calendar>
          </div>
          <div class="col-7">
            <div class="card-border-sm" *ngIf="showChart">
              <div class="title-chart">
                {{monthNameSelected}} - {{yearCalendar}}
              </div>
              <div class="container-chart" >
                <app-spline-area-chart [serie1]="seriesProgram" [serie2]="seriesLoad" [weeks]="weeksChart"></app-spline-area-chart>
              </div>
            </div>
            <div *ngIf="!showChart" style="margin-left:.5em">
              <h2 class="title-not-chart">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.TitleNotOrder' | translate}} {{monthNameSelected}}</h2>
              <div class="divider"></div>
              <p class="text-not-chart">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.TextNotOrder' | translate}}.</p>
            </div>
          </div>
        </div>


        <p-menu #offerMenu [model]="offerMenuitems" [popup]="true"></p-menu>
        <div style="padding-top:1em">
          <h2 *ngIf="weekDtos.length > 0" style="padding-top:1em;margin:0">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekTitle' | translate}} {{monthNameSelected}}</h2>
          <p *ngIf="weekDtos.length > 0" style="padding:.5em 0; margin:0;">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekSubtitle' | translate}}.</p>

          <div class="searchbar-container" *ngIf="weekDtos.length > 0">
            <span class="p-input-icon-left">
              <i class="pi pi-search"></i>
              <input type="text" pInputText placeholder="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.PlaceholderFilterProgram' | translate}}" class="full-width"  [(ngModel)]="searchTerm" (input)="filterLoads()" />
            </span>
          </div>

          <p-dataView [value]="filteredRegisters" [loading]="loading" [rows]="20" [paginator]="true"
            emptyMessage="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.EmptyResultsText' | translate}}">
            <ng-template let-dto pTemplate="listItem" let-index="index">
              <div class="col-12 mb-6">
                <div class="flex justify-content-between align-items-center ">
                  <h3>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekFieldText' | translate}}: {{dto.week}} - {{dto.year}}</h3>

                  <div class="flex gap-1" *ngIf="dto.importOrdersDtos.length > 0" >
                    <!-- *ngIf="dto.importOrdersDtos[0].importOrder.transportType == 0" -->
                      <p-button

                      styleClass="p-button-outlined"
                      [style]="{'font-size': 'small', 'margin-left': '10px'}"
                      label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.AddOrderButton' | translate}}"
                      icon="pi pi-plus"
                      (onClick)="showAddContainers(dto.week, dto.year, 'container')"
                      ></p-button>
                      <p-button
                      (onClick)="onToggleDetail(dto)"
                      [icon]="dto.expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                      styleClass="p-button-outlined p-button-rounded p-button-text p-button-sm"
                      class="btn-toggle"
                      [ngClass]="{
                        'btn-expanded': dto.expanded,
                        'btn-collapsed': !dto.expanded
                      }">
                    </p-button>
                  </div>
                </div>

                <div class="week-export-orders-dataview" *ngIf="dto.expanded">
                  <div class="list-scroll">
                    <p-dataView #dv
                    [value]="dto.importOrdersDtos"
                    [sortField]="sortField"
                    [sortOrder]="sortOrder"
                    [rows]="20"
                    [paginator]="false"
                    [loading]="loading"
                    emptyMessage="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.EmptyResultsText' | translate}}"
                    >
                      <ng-template pTemplate="header">
                      </ng-template>
                      <ng-template let-dto pTemplate="listItem">
                        <div class="card" [style]="{'margin-bottom': '20px'}">
                          <div class="container-row">
                            <div class="container-flex">
                              <div class="row-style border-lat">
                                <div class="container-flex-fit">

                                  <div class="container-img">
                                      <img loading="lazy" [src]="getIconUrl(dto.importOrder.directSaleProgram.exportOffer.variety.urlIcon) | speciesImageUrl" style="border-radius: 7px; width: 100%; max-width: 50px; height: auto;" alt="" *ngIf="dto.importOrder.directSaleProgram.exportOffer.variety.urlIcon"/>
                                    <span class="material-symbols-outlined" style="font-size:40px;opacity:.3;color:#8C2B87" *ngIf="!dto.importOrder.directSaleProgram.exportOffer.variety.urlIcon">
                                      no_photography
                                    </span>
                                  </div>
                                  <div class="flex-container container-main-info">
                                    <h2 class="text-main"  style="font-size: 14px;">{{dto.details[0].exportOffer.variety.species | speciesName}}</h2>
                                    <!-- <span style="text-transform: uppercase; font-size: medium;">{{dto.details[0].exportOffer.variety.name}}</span> -->
                                    <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.CodeText' | translate}}:</strong> {{dto.importOrder.sequence}}</span>
                                    <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.InstructiveText' | translate}}:</strong> {{dto.delivery.deliveryInstructions}}</span>
                                    <span style="font-weight: normal; font-size: 12px;"><strong style="color: #8c2b87">{{'ImportCloseSaleTable.ContainerText' | translate}}:</strong> {{dto.delivery.containerNumber}}</span>
                                  </div>
                                </div>
                                <div class="flex align-items-center">
                                  <span class="material-symbols-outlined" style="color: #8c2b87">pallet</span>
                                  <span style="margin-left: 10px;">{{dto.details[0].palletsQuantity}}</span>
                                </div>
                                <div class="flex align-items-center">
                                  <p-button
                                  [style]="{'font-size': 'small', 'padding':'.5em .7em'}"
                                  styleClass="p-button-outlined"
                                  label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.SeeOrderButton' | translate}}"
                                  icon="pi pi-shopping-bag" class="btn-icon" (onClick)="goToImportOrderDetail(dto.importOrder.guid)"
                                  >
                                  </p-button>
                                </div>
                              </div>
                              <div class="row-style">
                                <div class="col-12 md:col-8 flex justify-content-between align-items-center">
                                  <!-- <div class="flex justify-content-start align-items-center">
                                    <img [flag]="dto.importOrder.importFromCountry.code" height="40px" alt=""/>
                                    <div class="flex flex-column" style="margin-left: 10px;">
                                      <span style="font-weight: bolder; font-size: small;">{{dto.importOrder.importFromCountry.name}}</span>
                                    </div>
                                  </div> -->
                                  <app-location-info
                                  [type]="dto.importOrder.transportType"
                                  [countryName]="dto.importOrder.importFromCountry?.name"
                                  [countryCode]="dto.importOrder.importFromCountry?.code"
                                  ></app-location-info>
                                  <!-- <div class="flex flex-column justify-content-center align-items-center"> -->
                                    <!-- <div class="container-flex-fit">
                                      <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="dto.importOrder.transportType == 0" >directions_boat</span>
                                      <span class="material-symbols-outlined" style="color: #6da043;" *ngIf="dto.importOrder.transportType == 1" > flight</span>
                                      <span class="material-symbols-outlined" style="color: #6da043;">arrow_forward_ios</span>
                                    </div>
                                    <div *ngIf="dto.delivery?.ship" class="flex">
                                      <span class="text-center" style="font-size: small;">{{ dto.delivery?.ship }}</span>
                                    </div> -->
                                    <app-transport-type-icon [type]="dto.importOrder.transportType" [ship]="dto.delivery?.ship">

                                    </app-transport-type-icon>
                                  <!-- </div> -->
                                   <app-location-info [type]="dto.importOrder.transportType"
                                   [countryName]="dto.importOrder.importToCountry?.name"
                                   [countryCode]="dto.importOrder.importToCountry?.code"
                                   [portName]="dto.importOrder.importToPort?.name"
                                   [airportName]="dto.importOrder.destinationAirport?.name"
                                   [cityName]="dto.importOrder.destinationCity?.name"
                                   [showLocationName]="false">
                                   </app-location-info>

                                  <!-- <div class="flex justify-content-start align-items-center" *ngIf="dto.importOrder.transportType == 0">
                                    <img [flag]="dto.importOrder.importToCountry.code" height="40px" alt=""/>
                                    <div class="flex flex-column" style="margin-left: 10px;">
                                      <span style="font-weight: bolder; font-size: small; ">{{dto.importOrder.importToCountry.name}}</span>
                                    </div>
                                  </div>

                                  <div class="flex justify-content-start align-items-center" *ngIf="dto.importOrder.transportType == 1">
                                    <img [flag]="dto.importOrder.importToCountry" height="40px" alt=""/>
                                    <div class="flex flex-column" style="margin-left: 10px;">
                                      <span style="font-weight: bolder; font-size: small; ">{{dto.importOrder.importToCountry.name}}</span>
                                    </div>
                                  </div> -->
                                </div>

                                <div class="container-right-btns">
                                  <p-tag *ngIf="dto.importOrder.status == 5 " [value]="statuses[dto.importOrder.status].label" [severity]="getStatusSeverity(dto.importOrder.status)" [icon]="getStatusIcon(dto.importOrder.status)">
                                  </p-tag>
                                  <p-button
                                    [style]="{'font-size': 'small','line-height':'1.1em','padding':'.5em .7em'}"
                                    label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.DetailOrderTable.VerifyPalletsButton' | translate}}"
                                    icon="pi pi-table" (onClick)="goToVerifyPalletsPage(dto.details[0].guid)"
                                    styleClass="p-button-warning p-button-outlined" class="btn-icon" *ngIf="dto.details[0].status == 1 && dto.importOrder.status != 5"
                                    ></p-button>
                                  <p-button
                                    [style]="{'font-size': 'small','padding':'.5em .7em'}"
                                    label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.DetailOrderTable.SeePalletsButton' | translate}}"
                                    pTooltip="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.DetailOrderTable.SeePalletsButton' | translate}}"
                                    icon="pi pi-table" (onClick)="goToVerifyPalletsPage(dto.details[0].guid)"
                                    styleClass="p-button-outlined" class="btn-icon" *ngIf="dto.details[0].status == 4 && dto.importOrder.status != 5"></p-button>
                                    <div class="btn-expand-custom" style="margin-left: 15px;display:flex;align-items:center">
                                      <p-button
                                      [icon]="dto.importOrder.expanded ? 'pi pi-angle-up' : 'pi pi-angle-down'"
                                      styleClass="p-button-rounded p-button-outlined "
                                      (click)="setVisibleOrderDetail(dto.importOrder)"
                                      >
                                    </p-button>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class="container-flex">

                              <div *ngIf="dto.importOrder.expanded" class="container-expanded">
                                <div class="column-expanded-left">
                                  <div class="section-title">
                                    <span class="">{{'ImportCloseSaleTable.ProductDetailText' | translate}}</span>
                                  </div>
                                  <div class="flex">
                                    <div class="column-info-fit">

                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon">
                                          location_on
                                        </span>
                                        <span class="info-text">
                                          {{'ImportCloseSaleTable.LocationText' | translate}}:
                                        </span>
                                        <span class="info-text" style="margin-left: 1px;">
                                          <app-text-preview-tooltip
                                            [text]="dto.details[0].fridgeStorage ?
                                            dto.details[0].fridgeStorage.contactCity + ',' +
                                            dto.details[0].fridgeStorage.contactAddress :
                                            'No included'"
                                            [maxWidth]="300"
                                            ></app-text-preview-tooltip>
                                        </span>
                                      </div>

                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon">
                                          calendar_today
                                        </span>
                                        <span class="info-text">
                                          {{'ImportCloseSaleTable.HarvestDateText' | translate}}:
                                          {{dto.details[0].harvestDate ? (dto.details[0].harvestDate | date:'dd-MM-yyyy') : '-'}}
                                        </span>
                                      </div>

                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon">
                                          event
                                        </span>
                                        <span class="info-text">
                                          {{'ImportCloseSaleTable.ReadyToLoadDateText' | translate}}:
                                          {{dto.details[0].readyToLoadDate ? (dto.details[0].readyToLoadDate | date:'dd-MM-yyyy') : '-'}}
                                        </span>
                                      </div>

                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon" >
                                          monetization_on
                                        </span>
                                        <span class="info-text">
                                          {{'ImportCloseSaleTable.ListPriceText' | translate}}:
                                          <span *ngIf="dto.details[0].palletPrices.length == 1" class="info-text" style="margin-top: 10px;">
                                            {{dto.details[0].palletPrices[0].price | currency: 'USD':'US$'}}
                                          </span>
                                          <span class="info-text" *ngIf="dto.details[0].palletPrices.length == 0">
                                            {{'ImportCloseSaleTable.PriceNotEstablished' | translate}}
                                          </span>
                                        </span>
                                        <div *ngIf="dto.details[0].palletPrices.length > 1" class="see-prices" (click)="showCurrentPalletPriceModal(dto.details[0])">
                                          <span class="program-info-bold pl-2" style="color: #6da043;">
                                            {{'ImportCloseSaleTable.SeePrices' | translate}}
                                          </span>
                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>

                                <div class="flex-1"></div>

                                <div class="column-expanded-left pl-3">
                                  <div class="section-title">
                                    <span style="opacity:0">.</span>
                                  </div>
                                  <div class="flex">
                                    <div class="column-info-fit">

                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon" >
                                          pallet
                                          </span>
                                          <span class="info-text">
                                            {{'ImportCloseSaleTable.PalletText' | translate}}:
                                            {{dto.details[0].palletsQuantity}}
                                          </span>
                                      </div>
                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon">
                                          inventory_2
                                        </span>
                                        <span class="info-text"  *ngIf="dto.details[0].palletCaseConfig.length == 0">
                                          {{'ImportCloseSaleTable.CasePerPalletsText' | translate}}:
                                          {{dto.details[0].exportOffer.caseQuantityPerPallet}}
                                        </span>
                                        <span class="info-text"  *ngIf="dto.details[0].palletCaseConfig.length == 1">
                                          {{'ImportCloseSaleTable.CasePerPalletsText' | translate}}:
                                          {{dto.details[0].palletCaseConfig[0].boxesPerPallets }}
                                        </span>
                                        <div *ngIf="dto.details[0].palletCaseConfig.length > 1" class="see-prices" (click)="showCurrentCasesPerPallet(dto.details[0])">
                                          <span class="program-info-bold pl-2" style="color: #6da043;">
                                            {{'ImportCloseSaleTable.SeeCases' | translate}}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon">
                                          heart_check
                                          </span>
                                          <span class="info-text">
                                            {{'ImportCloseSaleTable.ShelfLifeText' | translate}}:
                                            {{dto.details[0].shelfLife ? dto.details[0].shelfLife : '-'}}
                                          </span>
                                      </div>
                                      <div class="row-info">
                                        <span class="material-symbols-outlined info-icon">
                                          calendar_month
                                        </span>
                                        <span class="info-text">
                                          {{'ImportCloseSaleTable.ProgramNameText' | translate}}:
                                          {{dto?.importOrder?.directSaleProgram?.name ?? '-'}}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="flex-1"></div>

                                <div class="" style="padding:0 1em;">
                                  <div class="">
                                    <div class="section-title">
                                      <span class="">{{'ImportCloseSaleTable.AgreementText' | translate}}</span>
                                    </div>
                                    <div class="flex flex-row align-items-center pb-2">
                                      <span class="material-symbols-outlined info-icon">
                                        person
                                        </span>
                                      <span class="info-text-program">
                                        Importer:
                                      </span>
                                      <span class="program-info">
                                          <app-text-preview-tooltip
                                          [text]="dto.importOrder.importer.companyName"
                                          [maxWidth]="200">
                                        </app-text-preview-tooltip>
                                      </span>
                                    </div>
                                    <div class="flex flex-row align-items-center pb-2">
                                      <span class="material-symbols-outlined info-icon">
                                        person
                                        </span>
                                      <span class="info-text-program">
                                        Consignee:
                                      </span>
                                      <span class="program-info">
                                        <app-text-preview-tooltip
                                          [text]="dto.importOrder.directSaleProgram.consigneeCompanyName"
                                          [maxWidth]="200">
                                        </app-text-preview-tooltip>
                                      </span>
                                    </div>
                                    <div class="flex flex-row align-items-center pb-2">
                                      <span class="material-symbols-outlined info-icon">
                                        person
                                      </span>
                                      <span class="info-text-program">
                                        Notify:
                                      </span>
                                      <span class="program-info">
                                          <app-text-preview-tooltip
                                          [text]="dto.importOrder.directSaleProgram.notifyCompanyName"
                                          [maxWidth]="200">
                                        </app-text-preview-tooltip>
                                      </span>
                                    </div>
                                    <!-- <div class="container-flex">
                                      <div class="flex justify-content-start align-items-center">
                                        <div class="container-week">
                                          <span class="material-symbols-outlined info-icon">
                                            calendar_today
                                          </span>
                                            <span class="program-info-bold"> {{dto.importOrder.closedSaleWeek}} - {{dto.importOrder.closedSaleWeekYear}}</span>
                                        </div>
                                      </div>
                                      <div class="edit-div pl-2">
                                        <div  class="flex flex-column">
                                          <div (click)="onEditWeek(dto.importOrder)">
                                            <span style="font-size: medium; color: #6da043;" class="material-symbols-outlined info-icon">
                                              edit
                                            </span>
                                            <span class="program-info-bold" style="color: #6da043; font-size: small;">
                                              {{'ImportCloseSaleTable.EditButtonLabel' | translate}}
                                            </span>
                                          </div>
                                          <div (click)="deleteOrder(dto.importOrder.guid)">
                                            <span style="font-size: medium; color: red;" class="material-symbols-outlined info-icon">
                                              delete
                                            </span>
                                            <span class="program-info-bold" style="color: red; font-size: small;">
                                              {{'ImportCloseSaleTable.DeleteText' | translate}}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div> -->
                                  </div>
                                </div>
                                <div class="flex-1"></div>

                                <div class="week-column">
                                  <div class="section-title">
                                    <span class="">{{'ImportCloseSaleTable.Week/Year' | translate}}</span>
                                  </div>
                                  <div class="container-flex">
                                    <div class="flex justify-content-start align-items-center">
                                      <div class="container-week">
                                        <span class="material-symbols-outlined info-icon">
                                          calendar_today
                                        </span>
                                          <span class="program-info-bold"> {{dto.importOrder.closedSaleWeek}} - {{dto.importOrder.closedSaleWeekYear}}</span>
                                      </div>
                                    </div>
                                    <div class="edit-div pl-2">
                                      <div  class="flex flex-column">
                                        <div (click)="onEditWeek(dto.importOrder)">
                                          <span style="font-size: medium; color: #6da043;" class="material-symbols-outlined info-icon">
                                            edit
                                          </span>
                                          <span class="program-info-bold" style="color: #6da043; font-size: small;">
                                            {{'ImportCloseSaleTable.EditButtonLabel' | translate}}
                                          </span>
                                        </div>
                                        <div (click)="validateDeleteProgram(dto.importOrder.guid)">
                                          <span style="font-size: medium; color: red;" class="material-symbols-outlined info-icon">
                                            delete
                                          </span>
                                          <span class="program-info-bold" style="color: red; font-size: small;">
                                            {{'ImportCloseSaleTable.DeleteText' | translate}}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                </div>

                              </div>
                            </div>
                        </div>
                      </ng-template>
                    </p-dataView>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-dataView>
        </div>
      </div>
    </div>
  </div>
</app-user-dashboard>



<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleExportOfferDialog" [style]="{width: '80%'}">
  <app-export-offer-detail [offer]="exportOffer" [productCertificateTypes]="selectedProductCertificateTypes" [packagingTypes]="selectedPackagingTypes"></app-export-offer-detail>
  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.CloseButton' | translate}}"
      (click)="visibleExportOfferDialog = false"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.ModalHeaderText' | translate}}"
  [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleAddProgramationDialog"
  [style]="{width: '80%'}">
  <form [formGroup]="formGroup">
    <h2>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.ModalTitle' | translate}}</h2>
    <div class="flex grid">
      <div class="col-12">
        <p-card header="Importador"
          subheader="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.CardHeaderText' | translate}}">
          <p-table [loading]="loading" [value]="importers" selectionMode="single" [(selection)]="selectedImporter"
            dataKey="id" (onRowSelect)="loadConsigneesNotifies()" responsiveLayout="stack" [breakpoint]="'600px'">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NewScheduleTable.NameHeader' | translate}}</div>
                </th>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NewScheduleTable.ContactHeader' | translate}}</div>
                </th>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NewScheduleTable.CountryHeader' | translate}}</div>
                </th>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NewScheduleTable.EmailHeader' | translate}}</div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-importer>
              <tr [pSelectableRow]="importer">
                <td>
                  <div class="flex justify-content-center align-items-center">{{importer.companyName}}</div>
                </td>
                <td>
                  <div class="flex justify-content-center align-items-center">{{importer.contactName}}</div>
                </td>
                <td>
                  <div class="flex justify-content-center align-items-center">{{importer.contactCountry | countryDescription}}</div>
                </td>
                <td>
                  <div class="flex justify-content-center align-items-center">{{importer.contactEmail}}</div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <small *ngIf="!selectedImporter"
                class="p-error">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NewScheduleTable.ImporterNotSelectedText' |
                translate}}</small>
            </ng-template>
          </p-table>
        </p-card>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <p-card header="Consignee"
          subheader="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.SelectConsigneeDescriptionText' | translate}}">
          <p-table [loading]="loading" [value]="consignees" selectionMode="single" [(selection)]="selectedConsignee"
            dataKey="id" responsiveLayout="stack" [breakpoint]="'600px'">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.ConsigneeTable.NameTableHeader' | translate}}</div>
                </th>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.ConsigneeTable.ContactHeader' | translate}}</div>
                </th>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.ConsigneeTable.CountryHeader' | translate}}</div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-consignee>
              <tr [pSelectableRow]="consignee">
                <td>
                  <div class="flex justify-content-center align-items-center">{{consignee.companyName}}</div>
                </td>
                <td>
                  <div class="flex justify-content-center align-items-center">{{consignee.contactName}}</div>
                </td>
                <td>
                  <div class="flex justify-content-center align-items-center">{{consignee.contactCountry | countryDescription}}</div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <small *ngIf="selectedImporter && !selectedConsignee" class="p-error">
                {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.ConsigneeTable.ConsigneeNotSelectedText' | translate}}</small>
            </ng-template>
          </p-table>
        </p-card>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <p-card header="Notify"
          subheader="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.SelectNotifyDescriptionText' | translate}}">
          <p-table [loading]="loading" [value]="notifies" selectionMode="single" [(selection)]="selectedNotify"
            dataKey="id" responsiveLayout="stack" [breakpoint]="'600px'">
            <ng-template pTemplate="header">
              <tr>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NotifyTable.NameTableHeader' | translate}}</div>
                </th>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NotifyTable.ContactHeader' | translate}}</div>
                </th>
                <th>
                  <div class="flex justify-content-center align-items-center">
                    {{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NotifyTable.CountryHeader' | translate}}</div>
                </th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-notify>
              <tr [pSelectableRow]="notify">
                <td>
                  <div class="flex justify-content-center align-items-center">{{notify.companyName}}</div>
                </td>
                <td>
                  <div class="flex justify-content-center align-items-center">{{notify.contactName}}</div>
                </td>
                <td>
                  <div class="flex justify-content-center align-items-center">{{notify.contactCountry | countryDescription}}</div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <small *ngIf="selectedImporter && !selectedNotify"
                class="p-error">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.NotifyTable.NotifyNotSelectedText' | translate}}</small>
            </ng-template>
          </p-table>
        </p-card>

      </div>
    </div>
    <p-divider></p-divider>
    <h2>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.ModalTitle2' | translate}}</h2>
    <div class="p-fluid formgrid grid">
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label for="importToCountryId">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.DestinationCountryFieldLabel' | translate}} *</label>
        <p-dropdown id="importToCountryId" [options]="countries" formControlName="importToCountryId" optionLabel="name"
          optionValue="id" (onChange)="loadPorts()" [filter]="true" filterBy="name" [showClear]="true"
          placeholder="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.DestinationCountryFieldPlaceholder' | translate}}"></p-dropdown>
        <small *ngIf="submit && formGroup.controls['importToCountryId'].invalid"
          class="p-error">{{getErrorMessage('importToCountryId')}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label for="portToId">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.DestinationPortFieldLabel' | translate}} *</label>
        <p-dropdown id="portToId" [options]="ports" formControlName="portToId" optionLabel="name" optionValue="id"
          [filter]="true" filterBy="name" [showClear]="true" placeholder="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.DestinationPortFieldPlaceholder' | translate}}"></p-dropdown>
        <small *ngIf="submit && formGroup.controls['portToId'].invalid"
          class="p-error">{{getErrorMessage('portToId')}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label for="palletQuantity">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.PalletsPerWeekFieldLabel' | translate}} *</label>
        <p-inputNumber id="palletQuantity" formControlName="palletQuantity" [showButtons]="false" [useGrouping]="false"
          [min]="1" placeholder="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.PalletsPerWeekFieldPlaceholder' | translate}}" />
        <small *ngIf="submit && formGroup.controls['palletQuantity'].invalid"
          class="p-error">{{getErrorMessage('palletQuantity')}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label for="startWeek">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.StartWeekFieldLabel' | translate}} *</label>
        <p-inputNumber id="startWeek" formControlName="startWeek" [showButtons]="true" [useGrouping]="false" [min]="1"
          [max]="52" placeholder="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.StartWeekFieldPlaceholder' | translate}}" />
        <small *ngIf="submit && formGroup.controls['startWeek'].invalid"
          class="p-error">{{getErrorMessage('startWeek')}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label for="startWeekYear">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.StartYearFieldLabel' | translate}} *</label>
        <p-dropdown id="startWeekYear" formControlName="startWeekYear" [options]="years" optionLabel="label"
          optionValue="value" placeholder="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.StartYearFieldPlaceholder' | translate}}">
        </p-dropdown>
        <small *ngIf="submit && formGroup.controls['startWeekYear'].invalid"
          class="p-error">{{getErrorMessage('startWeekYear')}}</small>
      </div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;"></div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.TotalWeeksLabel' | translate}}</label>
        <span style="font-weight: bolder; font-size: 1.5em;"> {{ totalWeeks }}</span>
      </div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.TotalPalletsScheduled' | translate}}</label>
        <span style="font-weight: bolder; font-size: 1.5em;"> {{totalPallets}}</span>
      </div>
      <div class="field col-12 md:col-6 lg:col-4" style="margin-bottom: 40px;">
        <label>{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.TotalContainersPerWeek' | translate}}</label>
        <span style="font-weight: bolder; font-size: 1.5em;"> {{containersPerWeek}}</span>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <p-button label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.CancelButton' | translate}}" (onClick)="visibleAddProgramationDialog = false"
      styleClass="p-button-outlined"></p-button>
    <p-button label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.NewScheduleModal.SaveButton' | translate}}" (onClick)="saveClosedSale()" [loading]="loading"></p-button>
  </ng-template>
</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CurrentPricesHeader' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCurrentPalletsPrice" [style]="{width: '800px'}">
  <p-table
  [value]="currentPrices"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.CategoryHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th>
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
      <th *ngIf="priceView">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PriceHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td>
        {{palletPrice.category}}
      </td>
      <td>
        {{palletPrice.speciesSize}}
      </td>
      <td>
        {{palletPrice.boxPerPallets}}
      </td>
      <td *ngIf="priceView">
        {{palletPrice.price | currency: 'USD'}}
      </td>
    </tr>
  </ng-template>
  </p-table>
</p-dialog>

<p-dialog header="{{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxesPerPalletsHeader' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleCurrentPalletsCases" [style]="{width: '70vw'}">
  <p-table
  [value]="palletCases"
  [paginator]="true"
  [rows]="10"
  [loading]="loading"
  responsiveLayout="stack"
  [breakpoint]="'600px'"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  >
  <ng-template pTemplate="header">
    <tr>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.VarietyHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.SpeciesSizeHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.PalletsHeader' | translate}}
      </th>
      <th  style="text-align: center;">
        {{'UserPages.UserPurchaseOrders.VerifyPalletsPage.PalletPriceModal.BoxQuantityHeader' | translate}}
      </th>
    </tr>
  </ng-template>
  <ng-template  pTemplate="body" let-palletPrice>
    <tr>
      <td style="text-align: center;">
        {{palletPrice.speciesName}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.varietyName}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.speciesSize}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.pallets}}
      </td>
      <td style="text-align: center;">
        {{palletPrice.boxesPerPallets}}
      </td>
    </tr>
  </ng-template>
      <ng-template pTemplate="footer">
    <tr>
      <td  style="text-align: center;">Total:</td>
      <td colspan="2" ></td>
      <td  style="text-align: center;">{{ getTotalPallets()  }}</td>
      <td  style="text-align: center;">{{ getTotalCases()  }}</td>
    </tr>
  </ng-template>
  </p-table>
</p-dialog>

<p-dialog header="{{'ImportCloseSaleTable.EditButtonLabel' | translate}}" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleEditWeek" [style]="{width: '400px'}">

  <ng-container *ngIf="editWeek">
    <form [formGroup]="weekFormGroup">

        <div class="p-fluid formgrid mr-2 ml-2 grid">
          <div class="field col-6 md:col-6 lg:col-6" style="margin-top: 20px;">
            <p-inputNumber
            id="week"
            formControlName="week"
            [showButtons]="true"
            [useGrouping]="false"
            [min]="1"
            [max]="52"
            placeholder="{{'UserPages.UserClosedSale.UserCreateClosedSale.StartWeekFieldPlaceholder' | translate}}"
            class="p-inputtext-sm"/>
          </div>
          <div class="field col-6 md:col-6 lg:col-6" style="margin-top: 20px;">
            <p-dropdown formControlName="year" appendTo="body" [options]="years" optionLabel="label" optionValue="value"
            placeholder="{{'UserPages.UserClosedSale.UserCreateClosedSale.StartYearFieldPlaceholder' | translate}}"
            class="p-inputtext-sm">
            </p-dropdown>
          </div>
            <!-- <label htmlFor="week">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekFieldLabel' | translate}}</label> -->
            <!-- <label htmlFor="year">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekYearFieldLabel' | translate}}</label> -->

          <!-- </div> -->
          <!-- <div class="p-float-label">
            <p-dropdown
            id="year"
            formControlName="year"
            [options]="years"
            optionLabel="label"
            optionValue="value"
            placeholder="{{'UserPages.UserClosedSale.UserCreateClosedSale.StartYearFieldPlaceholder' | translate}}"
            class="p-inputtext-sm">
            </p-dropdown>
            <label htmlFor="year">{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekYearFieldLabel' | translate}}</label>
          </div> -->
        </div>
      </form>
    </ng-container>


  <ng-template pTemplate="footer">
    <p-button *ngIf="editWeek" [style]="{'height': 'auto', 'margin-left': '5px'}" label="{{'UserPages.UserClosedSale.ExporterClosedSaleOrders.WeekSaveButtonLabel' | translate}}" (onClick)="saveWeek()" [loading]="loading"></p-button>
  </ng-template>
</p-dialog>

<p-dialog [header]="labelAdd" [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleAddContainers" [style]="{width: '400px'}">

    <form [formGroup]="addContainersForm">
        <div class="flex justify-content-between">
          <span class="p-float-label p-fluid">
            <p-inputNumber
            id="containersNumber"
            formControlName="containersNumber"
            [showButtons]="true"
            [useGrouping]="false"
            [min]="1"
            [max]="10"
            [placeholder]="labelAdd"
            class="p-inputtext-sm"/>
          </span>
        </div>
      </form>
  <ng-template pTemplate="footer">
    <p-button  [style]="{'height': 'auto', 'margin-left': '5px'}"
    label="{{'AddOrdersExporterClosed.AddContainersButton' | translate}}"
    (onClick)="addOrdersToWeek()" [loading]="loading"></p-button>
  </ng-template>
</p-dialog>

<p-sidebar [(visible)]="sidebarVisible" position="right">
  <h3 style="text-align: center;">{{'AdvancedFilters.SideBarTitle' | translate}}</h3>

  <form [formGroup]="othersFiltersForm">
    <div class="col-12 flex justify-content-center flex-column">
      <div class="col-12 flex justify-content-center flex-column">
        <p-calendar
          inputId="harvestDate"
          formControlName="harvestDate"
          appendTo="body"
          dateFormat="dd-mm-yy"
          [showButtonBar]="true"
          [showIcon]="true"
          [showWeek]="true"
          placeholder="{{'AdvancedFilters.HarvestDatePlaceholder' | translate}}"
          [firstDayOfWeek]="1"></p-calendar>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText inputId="netKilos" formControlName="kilosPerBox"
        placeholder="{{'AdvancedFilters.KilosPerBoxFieldPlaceholder' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <p-dropdown id="fridgeStorage"
          formControlName="fridgeStorageId"
          [options]="fridgeStorages"
          optionValue="id"
          optionLabel="name"
          [filter]="true"
          filterBy="name"
          autoWidth="false" [style]="{'width':'100%'}"
          [showClear]="true"
          placeholder="{{'UserPages.UserExportOffers.NewExportOffer.FridstorageFieldPlaceholder' | translate}}"
          emptyMessage="{{'UserPages.UserExportOffers.NewExportOffer.FridgestorageEmptyMessage' | translate}}"
          class="p-inputtext-sm">
        </p-dropdown>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="speciesSize" placeholder="{{'AdvancedFilters.SpeciesSizeFieldPlaceholder' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="shelfLife" [min]="1" [max]="1000" placeholder="{{'AdvancedFilters.ShelfLife' | translate}}"/>
      </div>
      <div class="col-12 flex justify-content-center flex-column">
        <input pInputText formControlName="price" placeholder="{{'AdvancedFilters.PricePlaceholder' | translate}}"/>
      </div>
        <div class="col-12 flex justify-content-center flex-columnr">
          <p-button (click)="onFilter()" label="{{'AdvancedFilters.ApplyFiltersText' | translate}}" styleClass="p-button">
            <span class="material-symbols-outlined">
              tune
              </span>
          </p-button>
        </div>
    </div>
  </form>
</p-sidebar>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleAssignForwarderDialog" [style]="{width: '30%'}">
  <ng-template pTemplate="header">
    <h2>{{ 'ForwarderPage.ForwarderReviewsPending.Modal.Title' | translate }}</h2>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="p-fluid formgrid grid">
      <div class="field col-12 xl:col-12 lg:col-12" style="margin-bottom: 40px;">
        <p-dropdown inputId="profileId" [(ngModel)]="selectedCompanyForwarder" [options]="companyForwarders" optionValue="id" optionLabel="companyName" placeholder="{{ 'ForwarderPage.ForwarderReviewsPending.Modal.SelectForwarderPlaceholder' | translate }}" [style]="{'minWidth':'100%'}" class="p-inputtext-sm" appendTo="body"></p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button [loading]="loading" label="{{ 'ForwarderPage.ForwarderReviewsPending.Modal.ButtonAssign' | translate }}" (onClick)="assignForwarder()"/>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleAssignCustomAgentDialog" [style]="{width: '30%'}">
  <ng-template pTemplate="header">
    <h2>{{ 'CustomAgentPage.CustomAgentReviewsPending.Modal.Title' | translate }}</h2>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="p-fluid formgrid grid">
      <div class="field col-12 xl:col-12 lg:col-12" style="margin-bottom: 40px;">
        <p-dropdown inputId="profileId" [(ngModel)]="selectedCompanyCustomAgent" [options]="companyCustomAgents" optionValue="id" optionLabel="companyName" placeholder="{{ 'CustomAgentPage.CustomAgentReviewsPending.Modal.SelectCustomAgentPlaceholder' | translate }}" [style]="{'minWidth':'100%'}" class="p-inputtext-sm" appendTo="body"></p-dropdown>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <p-button [loading]="loading" label="{{ 'CustomAgentPage.CustomAgentReviewsPending.Modal.ButtonAssign' | translate }}" (onClick)="assignCustomAgent()"/>
  </ng-template>
</p-dialog>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleValidationDelete" [style]="{width: '800px'}">

  <div class="w-full">
    <div style="margin-top: 20px;" class="flex justify-content-center">
      <span class="material-symbols-outlined" style="font-size: 100px; color: #8B2222;">
        cancel
        </span>
    </div>
    <h2 style="text-align: center;">{{'NoDeleteOrderMessage.TitleOrder'| translate}}</h2>
    <div class="flex justify-content-center">
      <span style="text-align: center;">{{'NoDeleteOrderMessage.MessageOrder'| translate : {orderSequence: orderSequence}   }}</span>
    </div>
    <div style="margin-top: 40px" class="w-full">
      <div class="flex align-items-center justify-content-center gap-4">
        <p-button label="{{'NoDeleteOrderMessage.CancelText'| translate}}" styleClass="p-button-outlined" (onClick)="visibleValidationDelete = false"></p-button>
        <p-button label="{{'NoDeleteOrderMessage.ReviewText'| translate}}"(onClick)="goToOrderDetail()"></p-button>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog [resizable]="false" [modal]="true" [draggable]="false" [(visible)]="visibleProgramChartDialog" [style]="{width: '50%'}">
  <ng-template pTemplate="header">
    <h2>{{ 'UserPages.UserClosedSale.ProgramChartTitle' | translate }}</h2>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="p-fluid formgrid grid align-items-cente">
      <div class="col-12">
        <div>
          <div class="container-chart" >
            <app-spline-area-chart [serie1]="seriesProgramRange" [serie2]="seriesLoadRange" [weeks]="monthsChart"></app-spline-area-chart>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog acceptLabel="{{'UserPages.UserClosedSale.YesLabel' | translate}}" rejectLabel="{{'UserPages.UserClosedSale.NotLabel' | translate}}" rejectButtonStyleClass="p-button-outlined" [style]="{width: '50vw'}"></p-confirmDialog>
